import { useCallback } from 'react';
import { useNavigate, type NavigateOptions } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';

export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const { localizedPath } = useLanguage();

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      navigate(localizedPath(to), options);
    },
    [navigate, localizedPath]
  );
}
